import { useState } from 'react'
import Swal from 'sweetalert2';
import { subtractCoins } from '../../../Api/LoadPanel/LoadPanel';
import { Request } from '../../../Api/Requests/models';
import { setAsPendingPayment } from '../../../Api/Requests/Requests';

interface Props {
    request: Request
    onHide: () => void
}

export const useAutoSubtract = ({ request, onHide }: Props) => {
    // const { getTime } = useGetTimeForHistory()
    const [loading, setLoading] = useState(false)

    const handleSuccess = async () => {
        await setAsPendingPayment({ id: request.id, reason: request.reason ?? '', amount: request.amount })
        onHide()
    }

    // MAIN FUNCTION
    const handleSubtractCoins = async () => {
        if (loading) { return }
        setLoading(true)

        try {
            const result = await subtractCoins({
                name: request.Player?.platformUser,
                quantity: request.amount.toString(),
            })


            if (result?.data?.success) {
                Swal.fire({ icon: 'success', text: `${request.amount} fichas bajadas a ${request.Player?.platformUser}` })
                handleSuccess()
            } else {
                const errorMessage = result?.response?.data?.message ?? 'Ha habido un error. Reinicia e intenta de nuevo.'
                Swal.fire({ icon: 'error', text: errorMessage });
            }

        } catch (error: any) {
            let errorMessage = error?.response?.data?.message ?? 'ERROR: No se ha podido bajar, verifica tu conexión y que el usuario tenga suficientes fichas disponibles.'
            Swal.fire({ icon: 'error', text: errorMessage, allowOutsideClick: false, allowEscapeKey: false });
        } finally {
            setLoading(false)
        }
    }

    return { handleSubtractCoins, loadingSubtract: loading }
}
